import axios from 'axios';
import config from '../config';

const STUDENT_API_URL = `${config.API_URL}/student`;

export const getStudentData = (roll_no) => {
    return axios.get(`${STUDENT_API_URL}?roll_no=${roll_no}`, {
    });
};
